import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Header from './Header';
import Footer from './Footer';
import { useDispatch } from 'react-redux';
import { getProfile } from './store/auth';
import { getDualByTrainerId } from 'store/friends';
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  useProtectedRoute(); // Call the hook to handle authentication redirects
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation();

  const getDualData = async () => {
    const currentPath = location.pathname;
    let userData = localStorage.getItem('userData');
    if (userData) {
      try {
      userData = JSON.parse(userData)
        
        // Only proceed if playerId exists
        if (!userData?.playerId) {
          console.log('[PROTECTED_ROUTE] No playerId in userData, skipping getDualData');
          return;
        }
        
      let payload = {
          trainer_id: userData.playerId,
      }

        let data;
        try {
          data = await dispatch(getDualByTrainerId(payload)).unwrap();
        } catch (error) {
          // Log the error but don't break the app
          const logData = {
            timestamp: new Date().toISOString(),
            message: 'getDualByTrainerId error: ' + (error?.message || 'Unknown error'),
            pathname: location.pathname,
            error: error?.response?.data || error?.message,
            payload: payload
          };
          console.error('[PROTECTED_ROUTE] getDualByTrainerId error:', logData);
          try {
            fetch('/api/api/log-client.php', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(logData)
            }).catch(() => {});
          } catch (e) {}
          return; // Exit early if there's an error
        }
        
      if (data && data?.duel_data && data?.duel_data?.id) {
        let challanged = userData?.playerName == data?.duel_data?.uitdager
          if (data?.duel_data?.status == 'wait' && !currentPath.includes('challange-request')) {
            const basePath = process.env.REACT_APP_BASE_PATH || '/';
            const path = basePath === '/' ? '/challange-request' : `${basePath}/challange-request`;
            window.location.href = `${path}?challanged=${challanged || false}&&duel=${data?.duel_data?.id}`;
          } else if (data?.duel_data?.status == 'accept' && !currentPath.includes('battle')) {
            const basePath = process.env.REACT_APP_BASE_PATH || '/';
            const path = basePath === '/' ? '/battle' : `${basePath}/battle`;
            window.location.href = `${path}?challanged=${challanged || false}&&duel=${data?.duel_data?.id}`;
        }
        } else if (currentPath.includes('challange-request') || (currentPath.includes('battle') && !window.location.search.includes('map=true') && !window.location.search.includes('trainer=true'))) {
          // Only redirect to home if it's NOT a map battle and NOT a trainer battle
          // Map battles and trainer battles don't have duel_data, so we shouldn't redirect them
          const basePath = process.env.REACT_APP_BASE_PATH || '/';
          const homePath = basePath === '/' ? '/home' : `${basePath}/home`;
          window.location.href = homePath;
        }
      } catch (error) {
        // Silently handle errors - don't break the app
        console.error('Error in getDualData:', error);
      }
    }
  }
  
  useEffect(() => {
    // Only run if authenticated
    if (!loading && isAuthenticated) {
      // Check for both token and session_token
      const token = localStorage.getItem('token');
      const sessionToken = localStorage.getItem('session_token');
      const hasToken = !!(token || sessionToken);
      const userData = localStorage.getItem('userData');
      
      if (hasToken && userData) {
        try {
          // Only call getProfile if we have userData with playerName
          const parsedUserData = JSON.parse(userData);
          if (parsedUserData?.playerName) {
            dispatch(getProfile());
          }
        } catch (e) {
          console.error('Error parsing userData:', e);
        }
        
    getDualData();
        const interval = setInterval(() => { getDualData() }, 10 * 1000);
        return () => clearInterval(interval); // Cleanup interval on unmount
      }
    }
  }, [isAuthenticated, loading, dispatch, location, navigate])
  return <>
    <div className='h-100'>
      {/* <Header /> */}
      <div className='child'>
        <Outlet />
      </div>
      {/* <Footer/> */}
    </div>
  </>;
};


const useProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const logToFile = (message) => {
    const logData = {
      timestamp: new Date().toISOString(),
      message: message,
      pathname: location.pathname,
      isAuthenticated: isAuthenticated,
      loading: loading,
      token: localStorage.getItem('token') ? 'EXISTS' : 'NOT_FOUND'
    };
    console.log('[PROTECTED_ROUTE]', logData);
    // Also try to send to server for logging
    try {
      fetch('/api/api/log-client.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(logData)
      }).catch(() => {}); // Ignore errors
    } catch (e) {}
  };

  useEffect(() => {
    // Always check localStorage first, as it's the source of truth
    // Check for both token and session_token
    const token = localStorage.getItem('token');
    const sessionToken = localStorage.getItem('session_token');
    const isActuallyAuthenticated = !!(token || sessionToken);
    
    logToFile(`Auth check - loading: ${loading}, isAuthenticated: ${isAuthenticated}, token exists: ${!!token}, session_token exists: ${!!sessionToken}, path: ${location.pathname}`);
    
    // Only redirect if we're sure there's no token or session_token
    if (!loading && !isActuallyAuthenticated && !isAuthenticated) {
      logToFile('No authentication - checking if redirect needed');
      // Only redirect if we're not already on login/register/forgot-password/main page
      const publicPaths = ['/login', '/register', '/forgot-password', '/', '/log'];
      const isPublicPath = publicPaths.some(path => location.pathname === path || location.pathname.startsWith(path + '/'));
      
      if (!isPublicPath) {
        logToFile('Redirecting to login');
        // Use navigate instead of window.location to avoid page reload
        const basePath = process.env.REACT_APP_BASE_PATH || '/';
        const loginPath = basePath === '/' ? '/login' : `${basePath}/login`;
        navigate(loginPath, { replace: true }); // Redirect to login if not authenticated
      } else {
        logToFile('On public path - no redirect needed');
      }
    } else if (!loading && isActuallyAuthenticated) {
      logToFile('Authenticated - access allowed');
    }
  }, [isAuthenticated, loading, navigate, location]);
};

export default ProtectedRoute;
